import _dottedPathToPopulation from '@/shared/functions/population-helpers/_dottedPathToPopulation';

export default function standardPromotionPopulation(
  path: string = '',
  { populateRoot = true }: { populateRoot?: boolean } = {}
) {
  const p = _dottedPathToPopulation(path);

  return {
    ...(populateRoot ? { [`populate${p}`]: 1 } : {}),
    [`populate${p}[promotionImages]`]: 1,
    [`populate${p}[eligibleTires][brand]`]: 1,
    [`populate${p}[eligibleTires][segment]`]: 1,
    [`populate${p}[eligibleTires][certifiedBy]`]: 1,
    [`populate${p}[eligibleTires][euTireLabel]`]: 1,
    [`populate${p}[eligibleTires][tireSize][tireDot]`]: 1,
    [`populate${p}[eligibleTireCategories]`]: 1,
    [`populate${p}[eligibleTireFeatures]`]: 1,
    [`populate${p}[eligibleBrands]`]: 1,
  };
}
